<template>
  <CCard>
    <CCardBody>
      <BTabs :active-tab.sync="active_tab">
        <BTab :title="$t('receiveCashDoc')">
          <ReceiveOperationCash/>
        </BTab>
        <BTab :title="$t('ReceiptList')">
          <ReceiveList/>
        </BTab>
        <BTab :title="$t('components.receiveCheque')">
<ReceiveOperationCheque/>
        </BTab>

        <BTab :title="$t('sidebars.chequeList')">
          <ReceiveChequeList/>
        </BTab>
      </BTabs>


    </CCardBody>

  </CCard>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
import BTabs from "../../tabs/BTabs";
// import the styles

import ReceiveList from "./ReceiveList";
import ReceiveOperationCash from "./ReceiveOperationCash";
import ReceiveOperationCheque from "./ReceiveOperationCheque";
import ReceiveChequeList from "./ReceiveChequeList";
import BTab from "../../tabs/BTab";
export default {
  name: 'ReceiveOperation',

  components: {
      BTab,
    Treeselect,
    BTabs,
    ReceiveChequeList,
    ReceiveList,
    ReceiveOperationCash,
    ReceiveOperationCheque
  },

  data() {
    var self = this;

    return {
        active_tab:0,
    }
  }, mounted() {

  }, watch: {

  },
  computed: {

  },
  methods: {

  }
}

</script>
